import { render, staticRenderFns } from "./batchSettingPurchaseGoods.vue?vue&type=template&id=5d781298&scoped=true&"
import script from "./batchSettingPurchaseGoods.vue?vue&type=script&lang=js&"
export * from "./batchSettingPurchaseGoods.vue?vue&type=script&lang=js&"
import style0 from "./batchSettingPurchaseGoods.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./batchSettingPurchaseGoods.vue?vue&type=style&index=1&id=5d781298&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d781298",
  null
  
)

component.options.__file = "batchSettingPurchaseGoods.vue"
export default component.exports